import { render } from "./CartHeaderTotal.vue?vue&type=template&id=1c3e69d4"
import script from "./CartHeaderTotal.vue?vue&type=script&lang=js"
export * from "./CartHeaderTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__